import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Reconstruye la ruta a partir de la configuración de rutas y corta en el primer
 * segmento parametrizado. Sirve tanto para el snapshot actual del router como
 * para el snapshot futuro que recibe un guard.
 */
export function baseIdDesdeSnapshot(root: ActivatedRouteSnapshot | null): string | null {
  const segmentos: string[] = [];
  let snapshot = root;

  while (snapshot) {
    const configPath = snapshot.routeConfig?.path ?? '';

    if (configPath) {
      for (const parte of configPath.split('/')) {
        if (!parte) continue;
        if (parte.startsWith(':') || parte === '**') {
          return segmentos.length ? `/${segmentos.join('/')}` : null;
        }
        segmentos.push(parte);
      }
    }

    snapshot = snapshot.firstChild;
  }

  return segmentos.length ? `/${segmentos.join('/')}` : null;
}
